
import { Options, Vue } from "vue-class-component";
import { FlagPermissionUrgentDeliveryManagement } from "@/feature-flags/flag-permission-urgent-management";

@Options({
  components: {},
  computed: {}
})
export default class UrgentDeliveryManagement extends Vue {
  get tabs() {
    return [
      {
        name: "urgent-pod",
        title: this.$t("urgentDeliveryManagement.tabPod"),
        permission: FlagPermissionUrgentDeliveryManagement.permission_urgent_delivery_management_pod_enable.isEnabled()
      },
      {
        name: "urgent-rts",
        title: this.$t("urgentDeliveryManagement.tabRts"),
        permission: FlagPermissionUrgentDeliveryManagement.permission_urgent_delivery_management_rts_enable.isEnabled()
      },
      {
        name: "urgent-hal",
        title: this.$t("urgentDeliveryManagement.tabHal"),
        permission: FlagPermissionUrgentDeliveryManagement.permission_urgent_delivery_management_hal_enable.isEnabled()
      },
      {
        name: "taken-by-recipient",
        title: this.$t("urgentDeliveryManagement.tabTakenByRecipient"),
        permission: FlagPermissionUrgentDeliveryManagement.permission_urgent_delivery_management_taken_enable.isEnabled()
      },
      {
        name: "monitor-relabel",
        title: this.$t("urgentDeliveryManagement.tabMonitorRelabel"),
        permission: FlagPermissionUrgentDeliveryManagement.permission_urgent_delivery_management_relabel_enable.isEnabled(),
        testId: "urgent-delivery-monitor-relabel-tab",
      },
    ];
  }
  changeTabs(value: string) {
    this.$router.push({
      name: value
    });
  }

  get availableTabs() {
    return this.tabs.filter((tab) => tab.permission);
  }

  isTabActive(name: string) {
    return name === this.$route.name;
  }

  mounted() {
    // to do
  }
}
